import {createVuetify, ThemeDefinition} from "vuetify";
import { useFavicon, useLocalStorage, useStyleTag } from '@vueuse/core';
import {aliases, mdi} from "vuetify/iconsets/mdi";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import 'vuetify/styles';
import '@/styles/styles.scss'
import axios from "axios";
import {getPublicContentURl} from "@/util";

// eslint-disable-next-line @typescript-eslint/no-var-requires
const {font} = require(`@/themes/default`)

const theme = {
  font: {
    url: font.url,
    name: font.name,
  },
  dark: false,
  colors: {
    background: '#FFFFFF',
    surface: '#FFFFFF',
    primary: '#3D405B',
    secondary: '#81B29A',
    tertiary: '#E07A5F',
    error: '#B00020',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FB8C00',
  },
  variables: {
    'border-color': '#000000',
    'border-opacity': 0.12,
    'high-emphasis-opacity': 0.87,
    'medium-emphasis-opacity': 0.60,
    'disabled-opacity': 0.38,
    'idle-opacity': 0.04,
    'hover-opacity': 0.04,
    'focus-opacity': 0.12,
    'selected-opacity': 0.08,
    'activated-opacity': 0.12,
    'pressed-opacity': 0.12,
    'dragged-opacity': 0.08,
    'theme-kbd': '#212529',
    'theme-on-kbd': '#FFFFFF',
    'theme-code': '#F5F5F5',
    'theme-on-code': '#000000',
  }
}
export const vuetify = {
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    },
  },
  theme: {
    defaultTheme: 'currentTheme',
    themes: {
      currentTheme: {
        dark: theme.dark,
        colors: theme.colors
      }
    }
  },
  components,
  directives,
};


export async function loadTheme() {
  const defaultTheme = (await axios.get(getPublicContentURl(`themes/${process.env.VUE_APP_FRAMEWORK_HOST}.json`))).data;
  const defaultFavicon = getPublicContentURl(`themes/${process.env.VUE_APP_FRAMEWORK_HOST}.ico`);
  const icon = useFavicon();
  icon.value = defaultFavicon;

  return {
    icons: {
      defaultSet: 'mdi',
      aliases,
      sets: {
        mdi,
      },
    },
    theme: {
      defaultTheme: 'currentTheme',
      themes: {
        currentTheme: {
          dark: defaultTheme.dark,
          colors: defaultTheme.colors
        }
      }
    },

    components,
    directives,
  };
}


useStyleTag(`@import url(${theme.font.url});`)
useStyleTag(`*,
  .text-caption,
  .text-body-1,
  .text-body-2,
  .text-h1,
  .text-h2,
  .text-h3,
  .text-h4,
  .text-h5,
  .text-h6 { font-family: ${theme.font.name}, sans-serif !important; }`)
